import { useMemo } from 'react';
import { BazanFieldGroup, BazanFieldKey } from '../enums/bazan';
import { SAPField } from '../components/forms/bazan/SAPNoteForm';

export function useBazanGroupFields(SAPFieldsData: SAPField[]) {
  return useMemo(() => {
    const groupMap: Record<BazanFieldGroup, BazanFieldKey[]> = {
      [BazanFieldGroup.Details]: [
        BazanFieldKey.FunctionalLocation,
        BazanFieldKey.Equipment,
        BazanFieldKey.EquipmentFailure,
      ],
      [BazanFieldGroup.TaskInfo]: [BazanFieldKey.Priority],
    };

    return SAPFieldsData.reduce((grouped, bazanField) => {
      const foundGroupEntry = Object.entries(groupMap).find(([, bazanFieldsKeys]) => {
        return bazanFieldsKeys.includes(bazanField.key as BazanFieldKey);
      });

      if (!foundGroupEntry) return grouped;
      const [groupKey] = foundGroupEntry;

      if (grouped[groupKey]) {
        return {
          ...grouped,
          [groupKey]: [...grouped[groupKey], bazanField],
        };
      }

      return {
        ...grouped,
        [groupKey]: [bazanField],
      };
    }, {}) as Partial<Record<BazanFieldGroup, SAPField[]>>;
  }, [SAPFieldsData]);
}
